// ============================================================================
// usePhoneLayout — the constitution's phone breakpoint (< 640px, §3) as state
// ============================================================================
// Header renders its phone parts (the 'Cattle ▾' switcher, the bottom bar) only
// on phones, and its desktop parts (the program strip, the section row) only
// above it, instead of keeping both in the DOM and hiding one with CSS. A hidden
// twin would still match text and role-less locators ('Herds', 'Dailys') and
// double every label for screen readers that ignore display:none parents.
// index.html carries the same split in CSS as the no-JS fallback.
// ============================================================================
import {useCallback, useSyncExternalStore} from 'react';

export const PHONE_QUERY = '(max-width: 639.98px)';
export const COARSE_POINTER_QUERY = '(hover: none) and (pointer: coarse)';

export function usePhoneLayout(query: string = PHONE_QUERY): boolean {
  const subscribe = useCallback(
    (listener: () => void): (() => void) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', listener);
      return () => mql.removeEventListener('change', listener);
    },
    [query],
  );
  const getSnapshot = useCallback((): boolean => {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;
  }, [query]);
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
